import { GETTERS } from "./names";

export default {
    [GETTERS.CURRENT_USER]: (_state, _getters, _rootState, rootGetters) => rootGetters['application/driver/authUser'],
};